import { useState } from "react";

export const useScheduleDetailV2 = () => {
  const [step, setStep] = useState(1);
  return { step, setStep };
};
